export default function formatPhone(phoneNumber: string): string {
  if (!phoneNumber) return '';

  const cleaned = phoneNumber.replace(/\D/g, '');
  const matched = cleaned.match(/(\d{3})(\d{3})(\d{4})(\d*)/);

  if (!matched) return '';

  const [areaCode, prefix, line, extension] = matched.slice(1);

  return `(${areaCode}) ${prefix}-${line}${extension && ' ext. '}${extension}`;
}

